/** Message shown when the backtesting server is saturated or not answering. */
export const SERVER_BUSY_MESSAGE =
  'Servidor de backtesting ocupado, por favor reinicia la página y reinténtalo.';

/** Consecutive failed job-status polls tolerated before declaring the server busy. */
export const MAX_JOB_POLL_FAILURES = 5;

/** True for timeouts, dropped connections and gateway errors - i.e. an overloaded server. */
export function isTransientError(err: unknown): boolean {
  const e = err as { code?: string; message?: string; response?: { status?: number } };
  if (!e) return false;
  if (e.code === 'ECONNABORTED' || e.code === 'ETIMEDOUT' || e.code === 'ERR_NETWORK') return true;
  if (e.message?.toLowerCase().includes('timeout') || e.message === 'Network Error') return true;
  const status = e.response?.status;
  return status === 502 || status === 503 || status === 504;
}

export function isNotFoundError(err: unknown): boolean {
  return (err as { response?: { status?: number } })?.response?.status === 404;
}

/** Remember a queued job in this browser so a page reload can follow it again. */
export function storeQueuedJobId(key: string, jobId: string) {
  try {
    if (jobId) localStorage.setItem(key, jobId);
    else localStorage.removeItem(key);
  } catch {
    // Storage unavailable (private mode...) - only resuming after reload is lost.
  }
}

export function getQueuedJobId(key: string): string {
  try {
    return localStorage.getItem(key) ?? '';
  } catch {
    return '';
  }
}
